<template>
  <div class="productListing">
    <section class="detail_content">
      <header class="main_customHeading">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h2>{{$t('productList')}}</h2>
      </header>
      <div class="addToHome" v-if="hideAddtoHomeShowJSbridge">
        <div
          :class="hideAddtoHomeShowJSbridge ? 'addtohomescreen active_homescreen' : 'addtohomescreen'"
        >
          <div class="logo-imgbox">
            <img :src="addTohomeImage" alt="add-to-home" />
          </div>
          <div class="textbox" @click="JsBridgeOpenPrompt()">
            <span id="ad2hs-prompt">Add {{DukaanbusinessName.toLowerCase()}} to Home Screen</span>
          </div>
          <div class="close-prompt">
            <i class="material-icons" @click="JsBridgehideAddtoHome()">close</i>
          </div>
        </div>
      </div>
      <CategoryFilterOption
        :dataValue="filterProducts"
        @closeAllCat="closeAllCat"
        @getFilterList="getAppliedFilterList"
        :isFilterOption="isFilterOption"
        :class="{'hideClass' : !isDisplay}"
      />
      <div
        :class="{'hideClass' : isDisplay, 'merchandiseProduct' : merchandiseId}"
        class="product_listing_detail"
      >
        <CategoryFilter
          :dataValue="filterProducts"
          @selectedCategory="getProductByCategory"
          @viewAllCat="viewAllCat()"
          :selectedcategoryName="selectedcategoryName"
          :choosedCatId="choosedCatId"
        />

        <div class="filter_product_list flx" v-if="merchandiseProductList.length > 0">
          <div
            ref="container"
            class="filter_card"
            v-for="(product,index) in merchandiseProductList"
            :key="index"
            @click="goToProductDetail(product.saleReferenceID)"
          >
            <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage">
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.displayImage" alt />
            </div>
            <div class="product_detail">
              <div class="my_price_section flx">
                <span class="my_price">₹​{{product.groupPrice}}</span>
                <span class="selling_price">₹​{{product.markedPrice}}</span>
              </div>
              <p class="bought">
                {{product.peopleBought}}
                {{$t('peopleHaveBrought')}}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="merchandiseProductStatus && trendingProductList.length == 0 && $route.params.mid"
          class="no_record"
        >
          <div class="page-status-panel">
            <div class="img-block">
              <img src="../assets/images/icons/norecord.svg" alt />
            </div>
            <div class="details-block">
              <h2>No Records Found</h2>
              <p>There was no record found that will you enter here.</p>
            </div>
          </div>
        </div>
        <div v-if="merchandiseProductStatus && merchandiseId == 0" class="no_record">
          <div class="page-status-panel">
            <div class="img-block">
              <img src="../assets/images/icons/norecord.svg" alt />
            </div>
            <div class="details-block">
              <h2>No Records Found</h2>
              <p>There was no record found that will you enter here.</p>
            </div>
          </div>
        </div>
        <infinite-loading @infinite="getProductsListing" spinner="circles">
          <template slot="no-more" v-if="!merchandiseProductStatus">{{$t('noMoreRecord')}}</template>
        </infinite-loading>
        <TrendingProductList
          :dataValue="trendingProductList"
          v-if="getTrendingList"
          :title="$t('trendingProd')"
          :class="{'getTrendingProduct': getTrendingList}"
        />

        <div class="cntntLoad" v-if="loading">
          <img src="../assets/images/loader.gif" alt="loader" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CategoryFilter from "../components/ProductListSection/CategoryFilter";
import TrendingProductList from "../components/HomeSection/TrendingProductList";
import CategoryFilterOption from "../components/ProductListSection/CategoryFilterOption";
import ImageSpinner from "../components/Common/ImageSpinner";
import { mapState, mapMutations } from "vuex";
export default {
  name: "MerchandiseIdProductListing",
  watch: {
    goBack() {
      this.$router.go(-1);
    }
  },
  components: {
    CategoryFilter,
    CategoryFilterOption,
    ImageSpinner,
    TrendingProductList
  },
  data() {
    return {
      merchandiseId: 0,
      pageIndex: 0,
      type: "TRENDING",
      merchandiseProductList: [],
      trendingProductList: [],
      title: "",
      filterProducts: {
        categoryFilterDTOs: null
      },
      isDisplay: false,
      choosedCatId: 0,
      selectedcategoryName: "",
      isFilterOption: false,
      loading: false,
      noRecord: false,
      merchandiseProductStatus: false,
      orderSourceType: null,
      trendingIndex: 0,
      getTrendingList: false,
      MerchantId: "",
      addTohomeImage: require("../assets/images/mall91_icon.png"),
      dukaanUniqueId: false,
      DukaanbusinessName: "Mall91",
      hideAddtoHomeShowJSbridge: false,
      existId: ""
    };
  },
  methods: {
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    JsBridgehideAddtoHome() {
      this.hideAddtoHomeShowJSbridge = false;
    },
    JsBridgeOpenPrompt() {
      window.Cstmbeforeinstallprompt.preventDefault();
      window.Cstmbeforeinstallprompt.prompt();
      let _self = this;
      window.Cstmbeforeinstallprompt.userChoice.then(choice => {
        if (choice.outcome === "accepted") {
          _self.hideAddtoHomeShowJSbridge = false;
        } else if (choice.outcome === "dismissed") {
          _self.hideAddtoHomeShowJSbridge = false;
        }
        window.Cstmbeforeinstallprompt = null;
      });
    },

    viewAllCat() {
      this.isDisplay = true;
    },
    closeAllCat() {
      this.isDisplay = false;
    },
    getProductByCategory(data) {
      this.loading = true;
      this.merchandiseProductStatus = false;
      this.title = this.displayName;
      this.choosedCatId = parseInt(data.categoryId);
      this.filterObject = data;
      this.pageIndex = 0;
      this.$store.commit("saveMerchandiseData", {
        merchandisePageIndex: this.pageIndex
      });
      delete this.filterObject.choosedCateName;
      this.merchandiseProductList = [];
      this.getProductsListing();
    },
    goToProductDetail(productSrId) {
      if (this.$route.query.source) {
        this.$router.push(
          "/detail/" + productSrId + "?source=APP_HOME_CAROUSEL"
        );
      } else {
        this.$router.onError(err => {
          if (/loading chunk \d* failed./i.test(err.message)) {
            window.location.reload();
          }
        });
        this.$router.push("/detail/" + productSrId);
      }
    },
    getClearanceSale() {
      this.loading = true;
      this.pageIndex = 0;
      this.$store
        .dispatch({
          type: "getProductType",
          payload: "PRODUCT?page=" + this.pageIndex
        })
        .then(data => {
          this.loading = false;
          this.trendingProductList =
            data.data.merchandiseCarouselProductDTOs[0].merchandiseProductDTOs;
        })
        .catch(err => {
          this.loading = false;
          this.busy = false;
          console.log(err);
        });
    },
    getProductsListing($state) {
      if (["CATEGORIES", "SELLER_CATEGORIES"].includes("NORMAL")) {
        let filterObj = this.filterObject;
        const scopeCategories = window.sessionStorage
          .getItem("scopeCategories")
          .split(",");
        const scopeSellers = window.sessionStorage
          .getItem("scopeSellers")
          .split(",");
        filterObj = {
          categoryId: this.filterObject
            ? this.filterObject.categoryId
            : this.categoryId,
          scopeCategories,
          scopeSellers
        };
      }
      if (this.$route.query.source) {
        this.orderSourceType = this.$route.query.source;
      } else {
        this.orderSourceType = null;
      }
      const filterObj = this.filterObject;
      if (this.$store.getters.merchandisePageIndex) {
        this.pageIndex = this.$store.getters.merchandisePageIndex;
      }
      this.$store.commit("saveMerchantId", {
        MerchantId: this.$route.params.mid
      });
      const obj = {
        merchandiseId: this.$route.params.mid,
        pageIndex: this.pageIndex,
        saleType: "NORMAL",
        filterRequestDTO: filterObj
      };
      this.$store
        .dispatch({
          type: "getMerchandiseProduct",
          payload: obj
        })
        .then(data => {
          if (data.data.filterDataDTO) {
            this.filterProducts = data.data.filterDataDTO;
            this.$store.commit("saveMerchandiseFilterData", {
              filterProdList: this.filterProducts
            });
          }
          if (data.data.saleProductDTOs.length > 0) {
            this.pageIndex += 1;
            this.merchandiseProductList.push(...data.data.saleProductDTOs);
            this.title = data.data.titile;
            this.choosedCatId = Number(data.data.categoryId);
            this.$store.commit("saveMerchandiseData", {
              merchandiseProdList: this.merchandiseProductList,
              merchandisePageIndex: this.pageIndex
            });

            this.loading = false;
            this.merchandiseProductStatus = false;
            $state && $state.loaded();
          } else {
            if (this.merchandiseProductList.length === 0) {
              this.merchandiseProductStatus = true;
            }
            this.loading = false;
            $state && $state.complete();
            this.getTrendingList = true;
            this.getClearanceSale();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    emitToaster(status) {
      let obj = {
        status: status,
        timeoutMs: "5000"
      };
      bus.$emit("apiStatus", obj);
    },
    getAppliedFilterList(data) {
      this.filterObject = data;
      this.choosedCatId = parseInt(data.categoryId);
      this.pageIndex = 0;
      this.$store.commit("saveMerchandiseData", {
        merchandisePageIndex: this.pageIndex
      });
      this.title = data.choosedCateName;
      delete this.filterObject.choosedCateName;
      this.merchandiseProductList = [];
      this.getProductsListing();
      this.isDisplay = false;
    },
    existMerchandiseId() {
      this.existId = this.$route.params.id;
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    if (this.$store.getters.MerchantId === this.$route.params.mid) {
      if (this.$store.getters.filterProdList) {
        this.filterProducts = this.$store.getters.filterProdList;
      }
      if (
        this.$store.getters.merchandiseProdList &&
        this.$store.getters.merchandiseProdList.length > 0 &&
        this.$store.getters.merchandisePageIndex
      ) {
        this.merchandiseProductList = this.$store.getters.merchandiseProdList;
        this.pageIndex = this.$store.getters.merchandisePageIndex;
      }
    } else {
      this.pageIndex = 0;
      this.$store.commit("saveMerchandiseData", {
        merchandisePageIndex: this.pageIndex
      });
    }
    if (this.merchandiseProductList.length == 0) {
      this.loading = true;
    } else {
      this.loading = false;
    }
    if (this.$route.query.type && this.$route.query.type != null) {
      this.type = this.$route.query.type;
    } else {
      this.type = "NORMAL";
    }

    if (typeof this.$route.params.mid != "undefined") {
      this.merchandiseId = this.$route.params.mid;
      this.pageIndex = 0;
    } else {
      this.merchandiseProductList = [];
    }
  },
  async created() {
    const [, , dukaanId] = window.location.pathname.split("/");
    if (dukaanId) {
      try {
        setTimeout(() => {
          let _self = this;
          window.addEventListener("beforeinstallprompt", e => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            if (e) {
              window.Cstmbeforeinstallprompt = e;
              _self.hideAddtoHomeShowJSbridge = true;
            }
          });
        }, 1000);
      } catch (err) {
        console.log(err);
      }
      try {
        document
          .getElementById("my-manifest-placeholder")
          .setAttribute(
            "href",
            `https://www.mall91.com/dukaan/${dukaanId}/manifest.json`
          );
        this.dukaanUniqueId = dukaanId;
        this.addTohomeImage = require("../assets/images/dukaan91.png");
      } catch (err) {
        console.log(err);
      }
      try {
        let dukaanData;
        await this.$store
          .dispatch({ type: "getDukaanCategory", payload: `${dukaanId}` })
          .then(data => {
            dukaanData = data.data;
          });
        let { businessName } = dukaanData;
        this.DukaanbusinessName = businessName;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>